module.exports = __webpack_public_path__ + "img/agv_EN.jpg";